import { Flex, Grid, Title, Text, Paper } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { HeartRhythmMeasurement } from 'models/heartRhythm/measurement';
import { SymptomIndicatorBar } from 'components/SymptomIndicatorBar/SymptomIndicatorBar';
import { CenteredLoading } from 'components/CenteredLoading';
import { defaultMeasurementIndicators, getHeartRhythmIndicatorColor } from 'utils/measurement';
import { PaperWithBorder } from 'components/PaperWithBorder';
import { getSymptomRhythmData } from './SymptomRhythmList.helpers';

interface SymptomRhythmInterface {
  measurements?: HeartRhythmMeasurement[];
}

export const SymptomRhythmList = ({ measurements }: SymptomRhythmInterface) => {
  const { t } = useTranslation();

  const dataInfo = getSymptomRhythmData(measurements);

  if (!measurements) {
    return (
      <Paper radius={'md'} p={'md'} withBorder>
        <CenteredLoading />
      </Paper>
    );
  }

  return (
    <PaperWithBorder testId={'symptom-rhythm-list'}>
      <Flex mb={'xs'} justify={'space-between'} align={'center'}>
        <Title mb={'sm'} order={4}>
          {t('patients_symptom_rhythm_title')}
        </Title>
      </Flex>
      {Object.entries(dataInfo).map(([symptom, indicators]) => {
        const totalMeasurements = Object.values(indicators).reduce((sum, v) => sum + v, 0);

        return (
          <Flex key={`symptom_${symptom}`} mb={'xs'}>
            <Grid w={'100%'} align={'center'}>
              <Grid.Col span={3}>
                <Text size={'sm'} fw={700}>
                  {t(`symptom_${symptom}`)}
                </Text>
              </Grid.Col>
              <Grid.Col span={9}>
                <Flex align={'center'}>
                  {Object.values(defaultMeasurementIndicators).map((indicator) => (
                    <SymptomIndicatorBar
                      key={`symptom_${symptom}_indicator_${indicator}`}
                      symptomValue={indicators[indicator] || 0}
                      barColor={getHeartRhythmIndicatorColor(indicator)}
                    />
                  ))}
                  <Text ml={'sm'}>
                    {measurements && totalMeasurements
                      ? Number((totalMeasurements / measurements?.length) * 100).toFixed(1)
                      : 0}
                    {'%'}
                  </Text>
                </Flex>
              </Grid.Col>
            </Grid>
          </Flex>
        );
      })}
    </PaperWithBorder>
  );
};
